import { message } from '@/components';
import { history } from 'umi';
import { useLocalStore } from 'mobx-react';
import { user as userModel, rtc } from '@/models';

export default function useMeetingFinish() {
  const { rtc: RTCInstance, user } = useLocalStore(() => {
    return {
      rtc,
      user: userModel,
    };
  });

  const logout = async (meetingId: string) => {
    try {
      user?.logout(meetingId);
      setTimeout(() => {
        RTCInstance && RTCInstance.destroy();
      }, 500);
    } catch (err: any) {
      if (err.message) {
        message.warning({
          content: err.message,
          noIcon: true,
        });
      }
    }
    history.replace({
      pathname: `feedback`,
    });
  };

  return logout;
}
